import { ReactNode, useCallback } from 'react';

import { ModalCancelButton, ModalCloseButton, ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { VisitId } from '~libs.shared.visit';

import { draftPrescriptionsTranslationKeys } from '../../../../../../translations';
import { DraftPrescriptionsFieldArray } from '../../DraftPrescriptionsForm.types';

import { usePatientEntitlementBenefitsCheck } from './PatientEntitlementBenefitsCheckEventInterceptor.hooks';
import { PatientEntitlementBenefitsCheckModalContent } from './PatientEntitlementBenefitsCheckModalContent';

type ContentRendererProps = {
   resolve: VoidFunction;
   reject: VoidFunction;
   closeModal: VoidFunction;
};
type ContentRenderer = (renderProps: ContentRendererProps) => JSX.Element;

type PatientEntitlementBenefitsCheckEventInterceptorProps = {
   readonly visitId: VisitId;
   readonly draftPrescriptions: DraftPrescriptionsFieldArray;
   readonly children: ReactNode;
};

export const PatientEntitlementBenefitsCheckEventInterceptor = (
   props: PatientEntitlementBenefitsCheckEventInterceptorProps
): JSX.Element => {
   const { children, draftPrescriptions } = props;
   const checkPatientEntitlementBenefits = usePatientEntitlementBenefitsCheck(props.visitId, draftPrescriptions);

   const content = useCallback<ContentRenderer>(
      ({ resolve, reject }) => (
         <>
            <PatientEntitlementBenefitsCheckModalContent
               draftPrescriptions={props.draftPrescriptions}
               onConfirm={resolve}
            />
            <ModalCancelButton onClick={reject} />
            <ModalCloseButton onClick={reject} />
         </>
      ),
      [props.draftPrescriptions]
   );

   return (
      <ShowModalEventInterceptor
         shouldShowModal={checkPatientEntitlementBenefits}
         title={draftPrescriptionsTranslationKeys.sendingRefundedPrescriptions}
         content={content}
         modalWidth={ModalWidth.NORMAL}
         testId={'patientEntitlementBenefits'}
         footerItemsHidden
      >
         {children}
      </ShowModalEventInterceptor>
   );
};
